import React from 'react';

import { MainMenu } from '@/app/view/App/MainMenu';

import s from './style.module.css';

interface IProps {
  children: React.ReactNode;
  onNavigate?: (uri: string) => void;
}

const MainLayout = ({ children, onNavigate }: IProps) => (
  <div className={s.root}>
    <MainMenu onNavigate={onNavigate} className={s.mainMenu} />
    <div className={s.container}>{children}</div>
  </div>
);

export { MainLayout };
